export default {
  joinPaths(...parts) {
    return parts
      .map((part, i) => {
        if (i === 0) return part.replace(/\/+$/, '');
        return part.replace(/^\/+|\/+$/g, '');
      })
      .filter(Boolean)
      .join('/');
  },
  serveBackendUrl(fileUrl, getters = {}) {
    if (fileUrl.startsWith('http')) return fileUrl;
    if (!Object.entries(getters).length) getters = this.$store.getters;
    return this.joinPaths(getters.baseBackendUrl, fileUrl);
  },
};
